




import Vue from 'vue';
import WindowCloseReason from '@/enums/WindowCloseReason';

export default Vue.extend({
  name: 'CloseWindowButton',
  methods: {
    closeWindow(evt: any) {
      (<any>window).closeReason = WindowCloseReason.UserCancel;
      window.close();
    },
  }
});



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/common/CloseWindowButton.vue